import { Center, Container, Divider, Heading, Text } from "@chakra-ui/react";

import DiscoverIconSM from "@/components/DiscoverIconSm";
import ExampleCard from "@/components/ExampleCard";
import Head from "next/head";
import SongCardDescription from "@/components/SongcardDescription";
import SubstackModal2 from "@/components/SubstackModal2";

export default function Home() {
  return (
    <>
      <Head>
        <title>What is a songcard? | Songcards Explained</title>
        <link rel="icon" href="/SC Icon_A_Light.svg" />
        <meta
          name="description"
          content="A songcard is a digital music collectable. It contains at least one song and one piece of artwork. Learn more and create your first Songcard today."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href="https://songcards.io/info" />

        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/info" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="What is a songcard? | Songcards Explained"
        />
        <meta
          property="og:description"
          content="A songcard is a digital music collectable. It contains at least one song and one piece of artwork. Learn more and create your first Songcard today."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="What is a songcard? | Songcards Explained"
        />
        <meta
          name="twitter:description"
          content="A songcard is a digital music collectable. It contains at least one song and one piece of artwork. Learn more and create your first Songcard today."
        />
        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
      </Head>
      <Container maxW="lg" py={10}>
        <Heading mb={6} textAlign="center">
          What is a songcard?
        </Heading>
        <Divider mb={10} mt={20} />
        <SongCardDescription />
        <Divider mb={10} mt={0} />
        <ExampleCard />
        <Center>
          <Text maxW={"md"} fontSize="xl" mt={100} mb={0}>
            <b>
              <i>
                As a huge music fan, being a collector on Songcards provides
                proof of how big a fan I am of an artist ~ Aaron
              </i>
            </b>
          </Text>
        </Center>
        {/* <ProofOfFan /> */}
        <Center>
          <Text fontSize="xl" mt={10} mb={20} maxW={"md"}>
            <b>
              <i>
                I love Songcards because it gives me first dibs at content from
                up and coming artists, in a format that is easy to access at any
                time ~ Iain
              </i>
            </b>
          </Text>
        </Center>
        <SubstackModal2 />
        <DiscoverIconSM />
      </Container>
    </>
  );
}
